// src/App.js

import React from 'react';
import UploadPage from './Components/UploadPage';

const App = () => {
  return (
    <div>
      <UploadPage />
    </div>
  );
};

export default App;

